<template>
  <section class="hero">
    <el-carousel v-if="slideImages.length" :interval="5000" arrow="always" height="420px" indicator-position="outside">
      <el-carousel-item v-for="item in slideImages" :key="item.id || item.mainImgUrl">
        <img :src="item.mainImgUrl" :alt="item.title || '轮播图'" class="hero__img" />
      </el-carousel-item>
    </el-carousel>
    <div v-else class="hero__placeholder">
      <div class="hero__placeholder-text">
        <h1>苏州市爱心达人公益慈善基金会</h1>
        <p>传递爱心 · 温暖社会</p>
      </div>
    </div>
  </section>
</template>

<script>
import { listSlide } from '@/api/cmsApi'

export default {
  name: 'HeroCarousel',
  data() {
    return {
      slideImages: []
    }
  },
  created() {
    listSlide()
      .then(res => {
        if (res.code === 200) {
          this.slideImages = res.data || []
        }
      })
      .catch(err => {
        console.warn('[HeroCarousel]', err.message)
      })
  }
}
</script>

<style scoped>
.hero {
  background: #1a1a1a;
}

.hero__img {
  width: 100%;
  height: 420px;
  object-fit: cover;
}

.hero__placeholder {
  height: 420px;
  background: linear-gradient(135deg, var(--color-primary-dark) 0%, var(--color-primary) 50%, var(--color-accent) 100%);
  display: flex;
  align-items: center;
  justify-content: center;
}

.hero__placeholder-text {
  text-align: center;
  color: #fff;
}

.hero__placeholder-text h1 {
  font-size: 32px;
  font-weight: 600;
  margin: 0 0 12px;
  letter-spacing: 2px;
}

.hero__placeholder-text p {
  font-size: 16px;
  opacity: 0.9;
  margin: 0;
  letter-spacing: 4px;
}

@media (max-width: 768px) {
  .hero__img,
  .hero__placeholder {
    height: 220px;
  }

  .hero__placeholder-text h1 {
    font-size: 22px;
  }
}
</style>

<style>
.hero .el-carousel__container {
  height: 420px !important;
}

@media (max-width: 768px) {
  .hero .el-carousel__container {
    height: 220px !important;
  }
}
</style>
